/**
 * features/attendance/AttendanceEntryTabs.tsx
 * ------------------------------------------------------------------
 * The "Entry" tab, split into three ways to record a register:
 *   Daily   — the detailed per-day screen (present/absent/late/excused/
 *             sick + notes). The place for nuanced status.
 *   Weekly  — a Mon–Fri checkbox grid for the chosen week.
 *   Monthly — the same grid across a whole month.
 * Weekly/Monthly default every pupil to present and let a teacher quickly
 * BACKFILL registers they didn't take day by day.
 * ------------------------------------------------------------------ */
import { useState } from 'react';
import { CalendarCheck, CalendarRange, CalendarDays, type LucideIcon } from 'lucide-react';
import DailyAttendance from './DailyAttendance';
import GridAttendance from './GridAttendance';

type Mode = 'daily' | 'weekly' | 'monthly';

const MODES: { key: Mode; label: string; icon: LucideIcon }[] = [
  { key: 'daily', label: 'Daily', icon: CalendarCheck },
  { key: 'weekly', label: 'Weekly', icon: CalendarRange },
  { key: 'monthly', label: 'Monthly', icon: CalendarDays },
];

export default function AttendanceEntryTabs() {
  const [mode, setMode] = useState<Mode>('daily');
  return (
    <div className="space-y-4">
      <div className="inline-flex items-center gap-1 p-1 rounded-xl bg-gray-100 dark:bg-gray-800">
        {MODES.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setMode(key)}
            className={`flex items-center gap-1.5 px-3.5 py-2 text-sm font-medium rounded-lg transition-colors ${
              mode === key
                ? 'seg-on'
                : 'seg-off'
            }`}
          >
            <Icon size={15} /> {label}
          </button>
        ))}
      </div>

      {mode === 'daily' && <DailyAttendance />}
      {mode === 'weekly' && <GridAttendance period="week" />}
      {mode === 'monthly' && <GridAttendance period="month" />}
    </div>
  );
}
